import {
    createTableColumn as createTableCol,
    type CreateTableColumnOptions,
    type TableColumnId,
    TableCellLayout,
    type TableColumnDefinition,
} from '@fluentui/react-components';

export const compare: TableColumnDefinition<any>['compare'] = (_a, _b) => 0;

interface CreateTableColumnProps<T extends Record<string, any> = Record<string, any>>
    extends Omit<
            CreateTableColumnOptions<T>,
            'columnId' | 'compare' | 'renderCell' | 'renderHeaderCell'
        >,
        Partial<Pick<CreateTableColumnOptions<T>, 'compare' | 'renderCell'>> {
    columnId: keyof T | TableColumnId;
    renderHeaderCell: CreateTableColumnOptions<T>['renderHeaderCell'] | string;
}

export const createTableColumn = <T extends Record<string, any>>(
    options: CreateTableColumnProps<T>
) =>
    createTableCol<T>({
        ...(options as CreateTableColumnOptions<T>),
        compare: options.compare || compare,
        renderCell:
            options.renderCell ||
            ((item) => (
                <TableCellLayout truncate={true}>{item[options.columnId as TableColumnId]}</TableCellLayout>
            )),
        renderHeaderCell:
            typeof options.renderHeaderCell === 'string'
                ? () => options.renderHeaderCell as string
                : options.renderHeaderCell,
    });

export const createTableColumns = <T extends Record<string, any>>(
    ...options: CreateTableColumnProps<T>[]
) => options.map(createTableColumn);
